import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/Nav";
import { UrgencyBanner } from "@/components/UrgencyBanner";
import { Hero } from "@/components/sections/Hero";
import { Marquee } from "@/components/Marquee";
import { Pillars } from "@/components/sections/Pillars";
import { About } from "@/components/sections/About";
import { Services } from "@/components/sections/Services";
import { BeforeAfter } from "@/components/sections/BeforeAfter";
import { WhyUs } from "@/components/sections/WhyUs";
import { Fiscal2028 } from "@/components/sections/Fiscal2028";
import { Testimonials } from "@/components/sections/Testimonials";
import { QuoteForm } from "@/components/sections/QuoteForm";
import { Footer } from "@/components/sections/Footer";
import { Careers } from "@/components/sections/Careers";
import { FloatingWhatsAppButton } from "@/components/FloatingCallButton";
import { Professionnels } from "@/components/sections/Professionnels";
import {
  CTASimpleLine,
  CTAFilledGold,
} from "@/components/sections/CTAs";
import Candidatures from "@/pages/Candidatures";

const Landing = () => (
  <>
    <UrgencyBanner />
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <Pillars />
      <About />
      <Services />
      <CTASimpleLine />
      <BeforeAfter />
      <CTAFilledGold />
      <Professionnels />
      <Marquee inverted />
      <WhyUs />
      <Fiscal2028 />
      <Testimonials />
      <QuoteForm />
      <Careers />
    </main>
    <Footer />
    <FloatingWhatsAppButton />
  </>
);

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);

    // Hijack in-page hash links so they scroll smoothly via Lenis,
    // accounting for the fixed top nav (~80px tall).
    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const href = anchor.getAttribute("href");
      if (!href || href === "#") return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      lenis.scrollTo(target, { offset: -124, duration: 1.2 });
    };
    document.addEventListener("click", onClick);

    return () => {
      document.removeEventListener("click", onClick);
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/candidatures" element={<Candidatures />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
